document.addEventListener('DOMContentLoaded', function () {
  var EVENT = 'acc-accessories-visibility-update';

  function normalizeQuery(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function getSearchQuery() {
    var input = document.querySelector('[data-find-accessories-input]');
    return normalizeQuery(input ? input.value : '');
  }

  function buildSearchText(card) {
    var preset = card.getAttribute('data-search-text');
    if (preset) return normalizeQuery(preset);

    var parts = [];

    if (card.matches('[data-product-card]')) {
      var tags = (card.getAttribute('data-product-tags') || '').split('|');
      tags.forEach(function (tag) {
        if (tag) parts.push(tag.replace(/-/g, ' '));
      });
      card
        .querySelectorAll('.card__heading, .card__vendor, .price-item, .card__badge')
        .forEach(function (el) {
          var text = (el.textContent || '').trim();
          if (text) parts.push(text);
        });
      return normalizeQuery(parts.join(' '));
    }

    ['data-sort-type-label', 'data-sort-product-title', 'data-type', 'data-type-2'].forEach(function (attr) {
      var value = card.getAttribute(attr);
      if (value) parts.push(value.replace(/-/g, ' '));
    });

    card.querySelectorAll('.product_type_label, .product_name, .accessory_title').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (text) parts.push(text);
    });

    return normalizeQuery(parts.join(' '));
  }

  function cardMatchesSearch(card, query) {
    if (!query) return true;
    return buildSearchText(card).indexOf(query) !== -1;
  }

  function isAccessoryCardVisible(card) {
    if (!card || card.hasAttribute('hidden')) return false;

    var section = card.closest('[data-acc-search-section]');
    if (!section || section.hasAttribute('hidden') || section.closest('[hidden]')) return false;

    var style = window.getComputedStyle(card);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function updateProductCounts() {
    document.querySelectorAll('[data-acc-search-section]').forEach(function (section) {
      var countEl = section.querySelector('[data-acc-product-count]');
      var list = section.querySelector('.shop_by_product .product_list');
      if (!countEl || !list) return;

      var visible = 0;
      list.querySelectorAll('.main_accessories').forEach(function (card) {
        if (isAccessoryCardVisible(card)) visible += 1;
      });
      countEl.textContent = String(visible);
    });
  }

  function requestUpdate() {
    document.dispatchEvent(new CustomEvent(EVENT));
    updateProductCounts();
  }

  window.AccAccessoriesVisibility = {
    EVENT: EVENT,
    getSearchQuery: getSearchQuery,
    cardMatchesSearch: cardMatchesSearch,
    requestUpdate: requestUpdate,
    updateProductCounts: updateProductCounts,
  };

  var form = document.querySelector('[data-find-accessories-form]');
  var input = document.querySelector('[data-find-accessories-input]');

  if (input) {
    var debounceTimer;

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(requestUpdate, 200);
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        requestUpdate();
      });
    }
  }

  updateProductCounts();
});
